import React from 'react';
import ReactDOM from 'react-dom';
import styles from './DefaultLandingPage.module.scss';
import { IDefaultLandingPageProps } from './IDefaultLandingPageProps';
import LivePageContainer from 'containers/PageBuilder/LivePageContainer';

const DefaultLandingPage: React.FC<IDefaultLandingPageProps> = (props: any) => {
  return (
    ReactDOM.createPortal(
        <div
        className={styles.default_landing_page_container}
        >
            <LivePageContainer
            //@ts-ignore
            pageSlug={
                props.group ?
                props.group.default_page.logged_out_default_page :
                undefined
            }
            hideDefaultFalseParam
            />
        </div>,
        //@ts-ignore
        document.getElementById('default-landing-page-portal-root')
    )
  )
}

export default DefaultLandingPage;